<div class="container-fluid p-0">
  <!-- Reset Password page start-->
  <div class="authentication-main">
    <div class="row">
      <div class="col-md-12 p-0">
        <div class="auth-innerright">
          <div class="authentication-box">
            <div class="card mt-4">
              <div class="card-header bg-info">
                <div class="text-center"><img src="../../../assets/images/logo/logo-inniver-small.png" alt=""></div>
              </div>
                <div class="card-body bg-grey">
                  <form class="ngx-form" [formGroup]="resetForm" novalidate>
                    <div class="form-row">
                      <h5 class="f-16 mb-3 f-w-600">CHANGE YOUR PASSWORD</h5>
                      <div class="col-md-12 mb-3">                        
                          <div class="form-group">
                            <label class="control-label" for="email">Email</label>
                            <input type="email" formControlName="email" class="form-control" autocomplete="off"
                              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$" [email]="true" required="required" placeholder="enter your email.." (keyup)="onKey($event)">
                            <div
                              *ngIf="resetForm.controls['email'].invalid && (resetForm.controls['email'].dirty || resetForm.controls['email'].touched)"
                              class="alert">
                              <div *ngIf="resetForm.controls['email'].errors?.['pattern']">
                                Email is required and format should be <i>john@doe.com</i>
                              </div>
                              <div *ngIf="resetForm.controls['email'].errors?.['required'] ">Email is required.</div>
                            </div>
                          </div>
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="col-md-12 mb-3">
                        <div class="form-group">
                          <label>Temporary key</label>
                          <input type="text" formControlName="key" class="form-control" placeholder="enter key.." (keyup)="onKey($event)">
                          <div *ngIf="resetForm.controls['key'].invalid && (resetForm.controls['key'].dirty || resetForm.controls['key'].touched)"
                            class="alert">
                            <div *ngIf="resetForm.controls['key'].errors?.['required']">
                              The key received in the email is required.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="col-md-6 mb-3">
                        <div class="form-group">
                          <label class="control-label" for="f1-password">New password</label>
                          <input type="password" formControlName="password" class="form-control" autocomplete="off"
                            placeholder="enter new password..">
                          <div
                            *ngIf="resetForm.controls['password'].invalid && (resetForm.controls['password'].dirty || resetForm.controls['password'].touched)"
                            class="alert">
                            <div *ngIf="resetForm.controls['password'].errors?.['required']">
                              Password is required.</div>
                            <div *ngIf="resetForm.controls['password'].errors?.['minlength']">Password must be at least 8 characters</div>
                          </div>
                        </div>
                      </div>
                    
                      <div class="col-md-6 mb-3">
                        <div class="form-group">
                          <label class="control-label" for="f1-repeat-password">Repeat password</label>
                          <input type="password" formControlName="confirmPassword" class="form-control" autocomplete="off"
                            placeholder="repeat new password..">
                          <div
                            *ngIf="resetForm.controls['confirmPassword'].invalid && (resetForm.controls['confirmPassword'].dirty || resetForm.controls['confirmPassword'].touched)"
                            class="alert">
                            <div *ngIf="resetForm.controls['confirmPassword'].errors?.['required']">
                              Password is required.</div>
                            <div *ngIf="resetForm.controls['confirmPassword'].errors?.['mustMatch']">
                              Password does not match
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                
                    <div class="f1-buttons">
                      <button class="btn btn-pill btn-primary btn-submit" type="submit" [disabled]="!resetForm.valid"
                      (click)="onSubmit()">Submit
                      </button>         
                    </div>
                    <div class="form-group">
                      <div class="col-md-12" *ngIf="isLoginFailed">
                        <label class="control-label" for="f1-password">Oops...</label>
                        <div class="text-center alert alert-danger">something went wrong</div>
                      </div>
                    </div>
                  </form>
              </div>
            </div>
            <div class="text-center">I'm having still trouble or <a class="btn-link"
              href="authentication/forgetpassword">forgot my password</a></div>
            <div class="text-center">Send me back to the <a class="btn-link"
              href="authentication/login">login page</a></div>
          </div>        
      </div>
    </div>
  </div>
  <!-- Reset Password page end-->
</div>